export const roundToTwoDecimalPlaces = (value: number) => Math.round(value * 100) / 100;
